import type { Workspace } from 'blockly/core';

import type { BoardDefinition } from '@skyrover/shared/types';

import {
  arduinoGenerator,
  type GeneratedSketch,
  registerBoardGeneratorExtension,
} from './arduino-generator.js';

import './block-generators.js';
import './beginner-block-generators.js';
import './beginner-led-generators.js';
import './beginner-switch-generators.js';
import './beginner-buzzer-generators.js';
import './beginner-microphone-generators.js';
import './beginner-speaker-generators.js';
import './beginner-serial-generators.js';
import './beginner-lcd-generators.js';
import './beginner-oled-generators.js';
import './beginner-tft-generators.js';
import './beginner-time-generators.js';
import './beginner-loop-generators.js';
import './beginner-math-generators.js';

export function generateSketch(
  workspace: Workspace,
  board: BoardDefinition,
): GeneratedSketch {
  return arduinoGenerator.generateSketch(workspace, board);
}

export {
  arduinoGenerator,
  registerBoardGeneratorExtension,
  type GeneratedSketch,
  type BoardGeneratorExtension,
} from './arduino-generator.js';

export { Order } from './arduino-generator.js';
